export const RolesNotToBePassedToAlgolia = ["any", "fresher"];

export function checkDateFormat(date) {
    return date === 'Present' ? new Date() : date.includes(' ') ? date : new Date(date);
}